module.exports = __webpack_public_path__ + "img/centennial-tic-resilience-quote6.c9c9a492.svg";